var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tlqn-hamburger-btn"},[_c('input',{attrs:{"type":"checkbox","disabled":_vm.disable},domProps:{"checked":_vm.value},on:{"input":_vm.handleInput}}),_c('span')])}
var staticRenderFns = []

export { render, staticRenderFns }